/**
 * お気に入り情報（mst004）テーブル操作用メソッド 
 */

// メモった！、キニッタ！共通メソッド
import * as GVar from '@/components/00/Var00';          // グローバル変数
import * as Tools from '@/components/00/Tools';         // 共通ツール
import * as GFunc from '@/components/00/Common00';    // 共通メソッド
import * as Mst001 from '@/components/00/db/Mst001'; 


export class Mst004DTO
{
   sys_cd = "";      // システムコード
   tmplt_cd = "";  // テンプレートコード
   uid: number;            // ユーザーID
   shp_id;      // 店舗ID
   add_ts = "";	    // 登録日時

   constructor (sys_cd: string, tmplt_cd: string, uid: number, shp_id: number)
   {
    this.sys_cd = sys_cd;      // システムコード
    this.tmplt_cd = tmplt_cd;  // テンプレートコード
    this.uid = uid;            // ユーザーID
    this.shp_id = shp_id;      // 店舗ID
    this.add_ts = "";          // 登録日時
   }
}

/**
 * mst004テーブル新規作成
 */
// export const create = async () =>
export const create = async function()
{
    const tabaleId = "mst004";
    if ( GFunc.isDebugEnabled() ) {console.log(tabaleId+" create()");}
    try
    {
        // テーブル新規作成
        const resp = await GVar.db.run("CREATE TABLE IF NOT EXISTS mst004 (sys_cd text, tmplt_cd text, uid integer, shp_id integer, add_ts text, PRIMARY KEY (sys_cd, tmplt_cd, uid, shp_id))");
        // バージョンNo.保存
        await Mst001.updateTabelVersionNo(tabaleId);
        if ( GFunc.isDebugEnabled() ) {console.log(tabaleId+"テーブルを作成しました。", resp);}
        return true;
    }
    catch(e)
    {
        console.log(GVar.sqliteErrorMsg+tabaleId+"テーブルの作成に失敗しました。："+`${e}`);
    }
}

/**
 * お気に入り情報に店舗を追加する
 *
 * @param mst004 Mst04DTO
 */
export const addMyFavorShop = async function(mst004: any)
{
    if ( GFunc.isDebugEnabled() ) { console.log("addMyFavorShop()"); }
    try
    {
        // お気に入り店舗を追加
        await GVar.db.run('insert into mst004 (sys_cd, tmplt_cd, uid, shp_id, add_ts) VALUES (?,?,?,?,?)',
            [mst004.sys_cd, mst004.tmplt_cd, mst004.uid, mst004.shp_id, Tools.getCurrentYyyymmddhhmmss()],
        );
    }
    catch(e)
    {
        console.log(GVar.sqliteErrorMsg+`${e}`);
    }
}

/**
 * お気に入り情報から店舗を削除する
 *
 * @param sys_cd システムコード
 * @param tmplt_cd テンプレートコード
 * @param uid ユーザーID
 * @param shp_id 店舗ID
 */
export const deleteMyFavorShop = async function(sys_cd: string, tmplt_cd: string, uid: number, shp_id: number)
{
    if ( GFunc.isDebugEnabled() ) { console.log("deleteMyFavorShop()"); }
    try
    {
        // お気に入り店舗を削除
        await GVar.db.run('delete from mst004 where sys_cd = ? and tmplt_cd = ? and  uid = ? and  shp_id = ?',
            [sys_cd, tmplt_cd, uid, shp_id]
        );
    }
    catch(e)
    {
        console.log(GVar.sqliteErrorMsg+`${e}`);
    }
}

/**
 * お気に入り情報から店舗一覧を取得する
 *
 * @param sys_cd システムコード
 * @param tmplt_cd テンプレートコード
 * @param uid ユーザーID
 * @returns 店舗IDの配列
 */
export const getMyFavorShops = async function(sys_cd: string, tmplt_cd: string, uid: number)
{
    if ( GFunc.isDebugEnabled() ) { console.log("getMyFavorShops()"); }
    try
    {
        // お気に入り店舗リストを取得
        const result = await GVar.db.query('select shp_id from mst004 where sys_cd = ? and tmplt_cd = ? and uid = ?',
            [sys_cd, tmplt_cd, uid]);    
        return result;
    }
    catch(e)
    {
        console.log(GVar.sqliteErrorMsg+`${e}`);
        return null;
    }
}

/**
 * お気に入りに登録済み店舗数を返す
 *
 * @param sys_cd システムコード
 * @param tmplt_cd テンプレートコード
 * @param uid ユーザーID
 * @param shp_id 店舗ID
 * @param funcOK 成功時コールバック関
 * @returns 店舗数
 */
export const countMyFavorShop = async function(sys_cd: string, tmplt_cd: string, uid: number, shp_id: number)
{
    if ( GFunc.isDebugEnabled() ) { console.log("countMyFavorShop()"); }
    try
    {
        // お気に入り店舗の存在をチェック
        const result = await GVar.db.query('select count(*) as cnt from mst004 where sys_cd = ? and tmplt_cd = ? and  uid = ? and  shp_id = ?',
            [sys_cd, tmplt_cd, uid, shp_id]);
        return result.values[0].cnt;
    }
    catch(e)
    {
        console.log(GVar.sqliteErrorMsg+`${e}`);
        return 0;
    }
}